module.exports = __webpack_public_path__ + "img/bg-1@1000x-80-min.c073808a.webp";